@if (progressStatus) {
  <div>
    <div class="progress-bar" [ngClass]="{'scrolled': isScrolled}">
      @if (progressBarConfig.length) {
        <div class="progress-line">
          @for (item of progressBarLinesConfig; track item; let i = $index) {
            <div class="line-item"
              [ngClass]="{'active': i === progressStatus.activeIndex}"
            ></div>
          }
        </div>
      }
      @for (item of progressBarConfig; track item; let i = $index) {
<div class="item" [ngClass]="{
      'active': i === progressStatus.activeIndex,
      'completed': i < (progressStatus.activeIndex || 0)
    }">
          <div class="round">
            <img class="icon" [src]="item.icon?.url" alt="">
            <img class="icon icon_mobile" [src]="item.icon_mobile?.url" alt="">
          </div>
          <span class="title">{{item.title}}</span>
        </div>
      }
    </div>
  </div>
}

